<script setup lang="ts">
import type { AppFunnelStep } from '~/types/commons'

interface Props {
  currentStep: AppFunnelStep | null
  currentStepIndex: number
  stepsCount: number
  showWizzardStepCount?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  currentStep: null,
  currentStepIndex: 0,
  stepsCount: 1,
  showWizzardStepCount: false,
})
</script>

<template>
  <div class="bg-gradient-to-r from-white from-50% to-gray-100 to-50%">
    <div class="mx-auto flex min-h-dvh max-w-screen-2xl">
      <div class="flex grow basis-3/5 flex-col items-end bg-white">
        <div class="w-full h-full justify-between flex flex-col px-4 pt-4 md:px-12 md:pt-8 lg:px-16 lg:pt-12 xl:px-24 xl:pt-24 pb-8 lg:pb-16">
          <div class="flex flex-col grow">
            <div class="flex items-center justify-between pb-4 lg:pb-12">
              <AppLogo class="h-5 w-auto md:h-6" />
              <div class="lg:hidden">
                <slot name="responsive-aside" />
              </div>
            </div>

            <YscDivider v-if="!props.currentStep?.hideWizzard" />

            <div
              v-if="!props.currentStep?.hideWizzard"
              class="flex items-center pt-4 lg:pt-8 text-sm text-gray-500 mb-1"
            >
              <slot name="wizzard-icon" />
              <span>{{ props.currentStep?.title }} {{ showWizzardStepCount ? `${props.currentStepIndex + 1}/${props.stepsCount}`: '' }}</span>
            </div>

            <div>
              <slot name="main" />
            </div>
          </div>

          <template v-if="!props.currentStep?.hideFooter">
            <YscDivider class="mt-8 mb-12" />

            <div class="flex justify-between">
              <slot name="footer" />
            </div>
          </template>
        </div>
      </div>

      <div class="hidden lg:relative lg:block lg:grow lg:basis-2/5 lg:bg-gray-100 lg:px-16 lg:pt-12 xl:px-24 xl:pt-24">
        <div
          v-if="$slots.aside"
          class="sticky top-4 xl:max-w-sm"
        >
          <slot name="aside" />
        </div>
      </div>
    </div>
  </div>
</template>
